import Link from '@commons/components/Link';

import type { CampaignPageNodeProps } from '.';

/**
 * CampaignPage node component for the Label display type.
 */

const CampaignPageNodeLabel = ({ title, alias }: CampaignPageNodeProps) => {
  return <Link href={alias}>{title}</Link>;
};

export default CampaignPageNodeLabel;
